import styled from "styled-components/macro";

export const StyledHelpMenu = styled.div`
  #help-container {
    position: relative;

    & > a svg {
      padding-bottom: 3px;
    }
  }

  .help {
    padding: 18px;
    background: var(--menu-color-fullscreen);
    box-shadow: var(--default-drop-shadow);
    border-radius: 18px;
    position: absolute;
    top: 46px;
    right: 0px;
    z-index: 100000;
    width: 350px;
    color: var(--grey-0) !important;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .section {
      display: flex;
      flex-direction: column;
      gap: 10px;

      span {
        font-size: 16px;
        font-weight: 600;
        color: var(--grey-0);
        font-weight: 600;
      }

      .button-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
      }
    }

    .footer {
      display: flex;
      flex-direction: row;
      gap: 12px;

      a {
        color: var(--grey-1);
        font-size: 12px;
        font-weight: 500;
      }
    }
  }
`;
